import React from 'react';
import PlayerStatsTableHeader from './PlayerStatsTableHeader';
import PlayerStatsTable from './PlayerStatsTable';
import PlayerStatsHeader from './PlayerStatsHeader';

const tableTitles = [
  'G',
  'MIN',
  'POS',
  'PTS',
  'FGM',
  'FGA',
  'FGM3',
  'FGA3',
  'FT',
  'FTA',
  'REBS',
  'OREBS',
  'DREBS',
  'AST',
  'TO',
  'STL',
  'BLK',
  'FOULS',
];

const PlayerTotalsStats = ({ stats }) => {
  if (!stats) return '';
  return (
    <div>
      <PlayerStatsTable>
        <PlayerStatsTableHeader titles={tableTitles} />
        <TableBody players={stats.team.players} />
      </PlayerStatsTable>
    </div>
  );
};

export default PlayerTotalsStats;

const TableBody = ({ players }) => (
  <tbody className="striped">
    {players.map(player => (
      <TableStatRow key={`${player.player.id}`} player={player} />
    ))}
  </tbody>
);

const formatValue = (numGames, value) => {
  if (numGames === 0) {
    return '-';
  }
  return Number.parseFloat(value.toFixed(2));
};

const TableStatRow = ({ player }) => (
  <tr>
    <PlayerStatsHeader player={player.player} />
    <td>
      {formatValue(player.calculated.num_games, player.calculated.num_games)}
    </td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.minutes)}</td>
    <td>
      {formatValue(player.calculated.num_games, player.calculated.possessions)}
    </td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.pts)}</td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.fgm)}</td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.fga)}</td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.fgm3)}</td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.fga3)}</td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.ft)}</td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.fta)}</td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.rebs)}</td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.rebso)}</td>
    <td>
      {formatValue(
        player.calculated.num_games,
        player.boxscore.rebs - player.boxscore.rebso,
      )}
    </td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.ast)}</td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.to)}</td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.stl)}</td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.blk)}</td>
    <td>{formatValue(player.calculated.num_games, player.boxscore.fouls)}</td>
  </tr>
);
